var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLightbulbOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 70c0 1.833 1.5 3.333 3.333 3.333h13.334C48.5 73.333 50 71.833 50 70v-3.333H30V70zM40 6.667C27.133 6.667 16.667 17.133 16.667 30c0 7.933 3.966 14.9 10 19.133v7.534C26.667 58.5 28.167 60 30 60h20c1.833 0 3.333-1.5 3.333-3.333v-7.534c6.034-4.233 10-11.2 10-19.133C63.333 17.133 52.867 6.667 40 6.667zm9.5 37-2.833 2v7.666H33.333v-7.666l-2.833-2C26 40.533 23.333 35.433 23.333 30c0-9.2 7.467-16.667 16.667-16.667 9.2 0 16.667 7.467 16.667 16.667 0 5.433-2.667 10.533-7.167 13.667z",
    fill: "#4BD5AD",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightbulbOutline);
export default __webpack_public_path__ + "static/media/ic-lightbulb-outline.eb8e1b2367a76d2a06fd92d005384c08.svg";
export { ForwardRef as ReactComponent };